// extracted by mini-css-extract-plugin
module.exports = {"containerPadding":"MainContainer_containerPadding__1Z6M2","container":"MainContainer_container__GIRhl"};